import {data}from "./data.js"

import Main from "../../components/Main/Main"


const Jupiter = ({overview}) => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Jupiter